// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import AdminSvg from '@rsuite/icon-font/lib/people/Admin';
var Admin = createSvgIcon({
  as: AdminSvg,
  ariaLabel: 'admin',
  category: 'people',
  displayName: 'Admin'
});
export default Admin;